import {
  AddressBasedTemplateCreatePage,
  type AddressBasedTemplatePageConfig,
} from "../check-arguments-templates-shared";

const config: AddressBasedTemplatePageConfig = {
  apiPathPrefix: "directorship",
  settingsPathPrefix: "directorship-templates",
  templateLabel: (t) => t("Directorship"),
  testIdPrefix: "directorship-template",
};

export function DirectorshipTemplateCreatePage() {
  return <AddressBasedTemplateCreatePage config={config} />;
}
